import { Markdown } from '../components/Markdown';
import toolsReference from './tools-reference.md?raw';

export function Tools() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Reference</p>
        <h1>Tools reference</h1>
        <p className="lede">
          The complete catalog of MCP tools and resources DreamGraph exposes. Anything the
          Architect can do, an MCP-compatible client can do too — these are the same surfaces.
        </p>
      </header>
      <article className="guide-content" style={{ maxWidth: 920, margin: '0 auto' }}>
        <Markdown source={toolsReference} />
      </article>
    </div>
  );
}
